<table class="w-full text-left rounded shadow rtl:text-right text-gray-500">
	<thead class="semi-bold sticky top-0 z-10 text-xs bg-emerald-500 text-white">
		<tr>
			<th (click)="handleSortClick.emit({ column: 'IsActive', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Active
				<i [class]="getSortIconClass('IsActive')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'CompanyName', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Company Name
				<i [class]="getSortIconClass('CompanyName')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'ContactName', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Contact
				<i [class]="getSortIconClass('ContactName')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'Address', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Address
				<i [class]="getSortIconClass('Address')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'City', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				City
				<i [class]="getSortIconClass('City')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'State', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				State
				<i [class]="getSortIconClass('State')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'Zip', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Zip
				<i [class]="getSortIconClass('Zip')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'Phone', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Phone
				<i [class]="getSortIconClass('Phone')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'Email', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Email
				<i [class]="getSortIconClass('Email')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'Notes', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Notes
				<i [class]="getSortIconClass('Notes')" class="ml-1"></i>
			</th>
		</tr>
	</thead>
	<tbody>
		<tr
			*ngFor="
				let installer of tableData
					| paginate
						: {
								itemsPerPage: 25,
								currentPage: viewStateService.pageNumber,
								totalItems: totalItems
						  }
			"
			class="border-b text-[12px] xl:text-sm text-black cursor-pointer hover:opacity-90"
			(click)="onRowSelect(installer)"
			[ngClass]="installer.rowBgColor"
		>
			<td class="py-2 px-2">
				<p class="flex items-center">
					{{ installer.isActive }}
				</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center semi-bold">{{ installer.CompanyName }}</p>
			</td>

			<td class="py-2 px-2">
				<p class="flex items-center">
					{{ installer.ContactName }}
				</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ installer.Address }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ installer.City }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ installer.State }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ installer.Zip }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ installer.Phone }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ installer.Email }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ installer.Notes }}</p>
			</td>
		</tr>
	</tbody>
</table>
<div *ngIf="tableData?.length === 0" class="text-center text-gray-500">
	<p>Nothing here.</p>
</div>
<div *ngIf="tableData?.length > 0" class="flex justify-between items-center mx-4 mt-2 mb-[100px]">
	<div>
		<pagination-controls (pageChange)="handlePaginationClick.emit($event)" class="pagination"></pagination-controls>
		<input class="h-10 !w-16 mr-4" [(ngModel)]="viewStateService.pageNumber" (input)="handlePaginationClick.emit()" />
	</div>
	<div *ngIf="viewStateService.mainTableTotalItems">
		<span class="semi-bold">Total Items:</span>
		{{ totalItems }}
	</div>
</div>
